



































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import draggable from 'vuedraggable'
import { TIAN_KONG, DUO_XUAN, DAN_XUAN } from './const'
let itemId = 0

@Component({
	components: {
		draggable,
	},
})
export default class QuestionList extends Vue {
	private TIAN_KONG = TIAN_KONG
	private DUO_XUAN = DUO_XUAN
	private DAN_XUAN = DAN_XUAN
	private visible = false
	private linkForm: any = {}
	private currentQuestion: any = {}
	private checkedTemp: string[] = []
	private questionList: any[] = []

	@Prop({})
	private list!: any

	@Watch('list', { immediate: true })
	private onListChange() {
		this.questionList = [...this.list]
	}

	private deleteQuestion(id: string) {
		this.$emit('deleteQuestion', id)
	}

	private onDragEnd() {
		this.$emit('changeOrder', this.questionList)
	}

	private getQuestionTitle(questionId: string) {
		const question = this.list.find(
			(question: any) => question.questionId === questionId
		)
		return question ? question.question : ''
	}

	private resetLink() {
		// 恢复默认值
		itemId = 0
		this.linkForm.resetFields()
		this.checkedTemp = []
	}

	private setRelation(question: any) {
		if (question.optionList && question.optionList.length > 0) {
			this.resetLink()

			let initialItemIds: number[] = [],
				initialListMap: any = {}
			question.optionList.forEach((item: any) => {
				if (typeof item.linkQuestionId !== 'undefined') {
					this.checkedTemp.push(item.optionId)
					initialListMap[itemId] = {
						optionId: item.optionId,
						questionId: item.linkQuestionId,
					}
					initialItemIds.push(itemId++)
				}
			})
			if (initialItemIds.length === 0) {
				// 无默认关联选项
				initialListMap[itemId] = {
					optionId: '',
					questionId: '',
				}
				initialItemIds.push(itemId++)
			}

			this.visible = true
			this.currentQuestion = question

			this.linkForm.setFieldsValue({
				linkItemIds: initialItemIds,
			})
			this.$nextTick(() => {
				// 渲染出field后再setFieldsValue
				const fields: any = {}
				initialItemIds.forEach((id: number) => {
					fields[`linkMap[${id}].optionId`] = initialListMap[id].optionId
					fields[`linkMap[${id}].questionId`] = initialListMap[id].questionId
				})
				this.linkForm.setFieldsValue(fields)
			})
		}
	}

	private onOptionChange(id: string) {
		this.checkedTemp.push(id)
	}

	private addLinkItem(id: string, index: number) {
		const itemIds = this.linkForm.getFieldValue('linkItemIds')
		const linkMap = this.linkForm.getFieldValue('linkMap')
		linkMap[itemId] = {
			optionId: '',
			questionId: '',
		}
		itemIds.splice(index + 1, 0, itemId++)
		this.linkForm.setFieldsValue({
			linkItemIds: itemIds,
			linkMap: linkMap,
		})
	}

	private removeLinkItem(id: string, index: number) {
		const itemIds = this.linkForm.getFieldValue('linkItemIds')
		const linkMap = this.linkForm.getFieldValue('linkMap')
		const optionId = linkMap[id] && linkMap[id].optionId

		// 释放当前项选项
		this.checkedTemp = this.checkedTemp.filter((id: string) => id !== optionId)
		delete linkMap[id]
		itemIds.splice(index, 1)
		this.linkForm.setFieldsValue({
			linkItemIds: itemIds,
			linkMap: linkMap,
		})
	}

	private onSave() {
		// 保存关联设置
		this.linkForm.validateFields((error: any, values: any) => {
			if (!error) {
				const optionQuesMap: any = {}

				values.linkItemIds.forEach((id: string) => {
					let temp = values.linkMap[id]
					if (temp) {
						optionQuesMap[temp.optionId] = temp.questionId
					}
				})
				this.currentQuestion.optionList.forEach((optionItem: any) => {
					this.$set(
						optionItem,
						'linkQuestionId',
						optionQuesMap[optionItem.optionId]
					)
				})
				this.visible = false
			}
		})
	}

	private created() {
		this.linkForm = this.$form.createForm(this)
		this.linkForm.getFieldDecorator('linkItemIds', {
			initialVal: [],
			preserve: true,
		})
	}
}
